import { render, staticRenderFns } from "./crearSedes.vue?vue&type=template&id=10c823b4"
import script from "./crearSedes.vue?vue&type=script&lang=js"
export * from "./crearSedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports